import {ValueObject} from '@s-ui/domain'
import {toQueryString} from '@s-ui/js/lib/string'

export class QueryParamSharedValueObject extends ValueObject {
  #key
  #value

  constructor({key, value}) {
    super()
    this.#key = key
    this.#value = value
  }

  static isEmpty({value}) {
    return Array.isArray(value) ? !this.value.length : value === undefined || value === null || value === ''
  }

  static sanitize({config, value}) {
    const noCodeRegex = config.get('REGEX_CODE')
    const decodedString = decodeURIComponent(value)
    const hasInvalidChars = noCodeRegex.test(decodedString)
    return hasInvalidChars ? null : decodedString
  }

  static create({key, value}) {
    return new QueryParamSharedValueObject({key, value})
  }

  static createForPipeArray({key, value}) {
    return new QueryParamSharedValueObject({key, value: value.join('|')})
  }

  static createForSingle({key, value}) {
    return new QueryParamSharedValueObject({key, value})
  }

  static createForIndexArray({key, value}) {
    return new QueryParamSharedValueObject({key, value: toQueryString(value, {arrayFormat: 'index', encode: false})})
  }

  static createWithSanitize({config, key, value}) {
    const sanitizedValue = Array.isArray(value)
      ? value.map(queryParamValue => QueryParamSharedValueObject.sanitize({config, value: queryParamValue}))
      : QueryParamSharedValueObject.sanitize({config, value})

    return new QueryParamSharedValueObject({key, value: sanitizedValue})
  }

  get key() {
    return this.#key
  }

  get value() {
    return this.#value
  }

  get isEmpty() {
    return Array.isArray(this.#value)
      ? !this.#value.length
      : this.#value === undefined || this.#value === null || this.#value === ''
  }

  get queryParam() {
    return {[this.#key]: this.#value}
  }

  get queryString() {
    return `${this.#key}=${this.#value}`
  }

  toJSON() {
    return {key: this.#key, value: this.#value}
  }
}
